import React, { useState } from "react";
import { useSelector } from "react-redux";

export default function BankWalaVision() {
  const authState = useSelector((state) => state.authReducer);
  const { isLoggedIn, userName, userCode } = authState || {};
    return (
      <div className="p-4 mx-auto">
        <div className="flex flex-col md:flex-row items-center md:items-start bg-gray-900 p-6 rounded-lg mb-8 gap-6">
          <div className="flex-shrink-0">
            <img
               src="/assets/imgFounders2.webp"
              alt="Sanjeev Kumar"
              className="w-28 h-28 rounded-full border-2 border-yellow-400"
            />
          </div>
          <div className="flex-1 text-center md:text-left">
            <blockquote className="border-l-4 border-yellow-400 pl-6 italic text-sm lg:text-lg text-gray-200">
              BankWala isn’t just an app — it’s a pathway to inner growth and a gateway to continuous learning for banking professionals, enabling all-round development in a world that constantly impacts the banking ecosystem.
            </blockquote>

            <footer className="mt-4 text-center lg:text-right text-sm text-yellow-300">
              Sanjeev Kumar, Founder, Think5Whys, Transformation-as-a-Platform
            </footer>
          </div>
        </div>

        <div className="space-y-6 text-gray-200 px-8">
          {/* Why BankWala Matters */}
          <section>
            <h2 className="text-xl font-bold text-white mb-4 text-center">Why BankWala Matters for Today’s Banker</h2>
            <p className="text-sm leading-relaxed">
              The banking world is evolving faster than ever—compliance pressure, monthly targets,
              customer expectations, operational load, digital adoption and constant audits.
              Yet most bankers get very little structured guidance, reflection time, or support
              to grow in a balanced, sustainable way.
              BankWala solves this gap by giving every banker a single platform to
              learn better, work smarter, stay compliant, and grow personally & professionally.
            </p>
          </section>

          {/* Continuous Learning */}
          <section>
            <h3 className="text-lg font-semibold text-white mb-3">Continuous Banking Learning — Stay Ahead, Stay Sharp</h3>
            <ul className="space-y-2 list-disc list-inside text-sm">

              <li>
                <strong>BankWala Learning:</strong>
                Micro-lessons, case studies, scenarios and updates for modern bankers.
                (Strengthens your <strong>Continuous Learning</strong> stack 📚)
              </li>

              <li>
                <strong>BankWala Bookshelf:</strong>
                Curated summaries, regulatory notes and leadership reads.
                (Builds your <strong>knowledge capital</strong> 📖)
              </li>

              <li>
                <strong>Podcasts:</strong>
                Listen to frontline experiences, tactical banking tips and expert discussions.
                (Part of your <strong>daily growth cycle</strong> 🎙️)
              </li>

              <li>
                <strong>bankTube:</strong>
                A distraction-free video space for banking insights, compliance explainer videos,
                customer-handling mastery and more.
                (<strong>Learning ecosystem</strong> ▶️)
              </li>

              <li>
                <strong>Trainings & Workshops:</strong>
                Improve productivity, sales confidence, risk skills and leadership.
                (Brings modern training to <strong>banking practice</strong> 🎓)
              </li>

            </ul>
          </section>

          {/* Productivity */}
          <section>
            <h3 className="text-lg font-semibold text-white mb-3">Productivity Tools — Work Smarter, Not Harder</h3>
            <ul className="space-y-2 text-sm">

              <li>
                <strong>TRACK:</strong>
                Your personal accountability engine—transparency, readiness & performance.
                (Supports <strong>daily execution excellence</strong> 🚦)
              </li>

              <li>
                <strong>Self Assessment:</strong>
                Evaluate skills, gaps and strengths scientifically.
                (<strong>Competency clarity</strong> 🙋‍♀️)
              </li>

              <li>
                <strong>DeepThinking Lab:</strong>
                Structured thinking to solve branch issues, customer complaints and targets.
                (<strong>Brainstorm engine</strong> 🧩)
              </li>

              <li>
                <strong>Minutes of Meeting:</strong>
                Capture MOMs quickly—auto reminders, follow-ups & action logs.
                (<strong>Execution discipline</strong> 📝)
              </li>

              <li>
                <strong>Goal Board:</strong>
                Visual monthly achievement plan—targets, conversion, compliance, customer scores.
                (<strong>Goal alignment</strong> 🎯)
              </li>

              <li>
                <strong>Kanban:</strong>
                Clear task flow—what’s pending, ongoing and completed.
                (<strong>Smart work management</strong> 🗂️)
              </li>

              <li>
                <strong>TrackBuddy AI:</strong>
                AI insights on productivity, readiness & improvements.
                (<strong>Your digital co-pilot</strong> 🔷)
              </li>

            </ul>
          </section>

          {/* Banker Self Reflection */}
          <section>
            <h3 className="text-lg font-semibold text-white mb-3">Self-Reflection — The Mark of a Modern Professional</h3>
            <ul className="space-y-2 text-sm">

              <li>
                <strong>BankWala Ranking:</strong>
                Track your growth with a balanced score across skills, habits and performance.
                (<strong>Self-awareness dashboard</strong> 🏆)
              </li>

              <li>
                <strong>Digital Card:</strong>
                Your professional identity & credibility in one place.
                (<strong>Banker Portfolio</strong> 📘)
              </li>

              <li>
                <strong>AI Counselling:</strong>
                Get clarity on decisions, conflicts, stress & workplace confusion.
                (<strong>Professional clarity</strong> 🧠)
              </li>

              <li>
                <strong>BankWala Diary:</strong>
                Track emotions, challenges, gratitude & achievements.
                (<strong>Reflective journal</strong> 🪞)
              </li>

              <li>
                <strong>Focus Timer:</strong>
                Increase depth work with structured focus blocks.
                (<strong>Better concentration</strong> ⏱️)
              </li>

              <li>
                <strong>IKIGAI:</strong>
                Understand your purpose, strengths & long-term direction.
                (<strong>Career alignment</strong> 🌸)
              </li>

              <li>
                <strong>Forum:</strong>
                Discussions for bankers—share views, ask doubts, learn from peers.
                (<strong>Community learning</strong> 🗣️)
              </li>

            </ul>
          </section>

          {/* Micro Earning */}
          <section>
            <h3 className="text-lg font-semibold text-white mb-3">Micro-Earning — Earn Through Learning & Contribution</h3>
            <ul className="space-y-2 text-sm">

              <li>
                <strong>Monthly Digital Income:</strong>
                Earn through tasks, participation, contributions and learning streaks.
                (<strong>Structured earning</strong> 💻🌱)
              </li>

              <li>
                <strong>Rewarding Videos & Ads:</strong>
                Watch professional content and earn.
                (<strong>Valuable screen time</strong> 🎥📢)
              </li>

              <li>
                <strong>Kharcho Jeeto:</strong>
                Win rewards through meaningful actions and positive habits.
                (<strong>Reward ecosystem</strong> 💰)
              </li>

              <li>
                <strong>Referral Income:</strong>
                Invite fellow bankers to the professional growth movement.
                (<strong>Network income</strong> 🔗)
              </li>

            </ul>
          </section>

          {/* Marketplace */}
          <section>
            <h3 className="text-lg font-semibold text-white mb-3">Engagements & Marketplace</h3>
            <ul className="space-y-2 text-sm">
              <li><strong>Marketplace:</strong> Tools, templates, books and productivity resources. 🛍️</li>
              <li><strong>BankWala MetaVerse:</strong> Immersive learning & simulated branch experiences. 🕶️</li>
              <li><strong>BankWala Games:</strong> Skill-based games for decision-making & analysis. 🎮</li>
            </ul>
          </section>

          {/* AI Section */}
          <section>
            <h3 className="text-lg font-semibold text-white mb-3">Your AI Mentor — BankWala AI</h3>
            <p className="text-sm leading-relaxed">
              Ask banking questions, clarify rules, understand customer scenarios,
              decode compliance requirements and get growth guidance—
              all through BankWala AI.
              (Strengthens your <strong>AI Banking Intelligence</strong> 🤖)
            </p>
          </section>

          {/* CTA */}
          <section>
            <h3 className="text-lg font-semibold text-white mb-3">Your Journey Starts Today</h3>
            <p className="text-sm leading-relaxed">
              Whether you want to upgrade skills, increase productivity, reflect on your career,
              or build consistent habits—BankWala adapts to you.
              One platform. Many possibilities. Real growth.
            </p>

            <div className="text-center mt-6">
              <button className="px-6 w-64 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700">
                Start Your BankWala Journey
              </button>
            </div>
          </section>

        </div>

      </div>
    );
  };